import { isModuleActive } from "../constants/rights-constants";

/**
 * ¿La descarga de este asset está bloqueada por derechos vencidos?
 *
 * Los dos flags se leen con isModuleActive, que aplica el mismo default que
 * MODULE_DEFAULTS en bunkey.objects cuando la clave todavía no está en la
 * cuenta. Antes se usaba un `.some()` pelado: para blockDownloadOnExpiredRights
 * —encendido por defecto, porque el bloqueo ya vive en producción— eso daba
 * false y el front habilitaba una descarga que el backend después rechazaba.
 */
export const isRightsDownloadBlocked = (asset, modules) => {
  if (!asset || asset.type === "folder" || asset.type === "bunker") return false;

  // canDownload viene del endpoint de detalle de derechos, que es la fuente
  // autoritativa. Cuando está, manda.
  if (asset.canDownload === false) return true;

  const useRightsActive = isModuleActive(modules, "useRights");
  const blockExpiredActive = isModuleActive(
    modules,
    "blockDownloadOnExpiredRights"
  );

  return useRightsActive && blockExpiredActive && asset.rightsState === "expired";
};
